import { createAsyncThunk } from '@reduxjs/toolkit';

import { AuthService } from '@/Module/Auth/Service';

export const authIsUserAction = createAsyncThunk<boolean, string>('auth/isUser', async (phoneNumber, { signal }) => {
  return AuthService.isUser(
    {
      phoneNumber,
    },
    signal,
    {
      disabledAutoError: true,
    },
  ).then(() => true);
});
